import Image from 'next/image'

import FansiMark from '@/atoms/FansiMark'
import generateBlurDataURL from '@/helpers/generateBlurDataURL'
import FansiKind from '@/ts/enums/global/FansiKind'
import { FansiVideoCreatorProps } from '@/views/product/ts'

function FansiVideoCreator(props: FansiVideoCreatorProps) {
  const { name, src } = props
  const blur = generateBlurDataURL(400, 320)

  return (
    <div className="flex flex-col space-y-8 2md:space-y-0 2md:flex-row 2md:items-start 2md:space-x-6">
      <figure className="2md:w-[240px] mx-auto 2md:mx-0 2md:h-[320px] h-[400px] w-full max-w-[340px] 2xl:w-[320px] 2xl:h-[400px] flex-shrink-0 relative overflow-hidden rounded-lg">
        {src && (
          <Image
            alt={name}
            src={src}
            layout="fill"
            objectFit="cover"
            placeholder="blur"
            blurDataURL={blur}
            quality={75}
            loading="eager"
          />
        )}
      </figure>
      <div>
        <h2 className="mb-2 text-xl font-medium break-words md:mb-4 md:text-2xl 2xl:text-3xl">
          {name}
        </h2>
        <div className="flex items-center space-x-4">
          <span className="text-black/80">fansi Video</span>
          <FansiMark kind={FansiKind.FansiVideo} />
        </div>
      </div>
    </div>
  )
}

export default FansiVideoCreator
